import { isNil } from "lodash";
import { FORMAT_DATE_STD } from "src/utils/formatters";

import moment from "moment-timezone";
import { ALL_DAYS_OF_THE_WEEK } from "src/types/enum/DayOfTheWeek";

export const disableFuture = (date: Date): boolean => {
    return date > new Date();
};

export function maxNegativeTimezone(timezones: string[]): string {
    let maxNegativeTimezone = timezones[0];

    timezones.forEach((timezone) => {
        const offset = moment.tz(timezone).utcOffset();
        if (maxNegativeTimezone === null || offset < moment.tz(maxNegativeTimezone).utcOffset()) {
            maxNegativeTimezone = timezone;
        }
    });

    return maxNegativeTimezone;
}

export function getShiftedDate(date: Date, shift: moment.Duration, posTimezone: string): string {
    const shiftedDate = moment(date).tz(posTimezone).tz("UTC", true);

    if (shift > moment.duration(24, "hours")) {
        shiftedDate.subtract(shift.clone().subtract(moment.duration(24, "hours")));
    }

    return shiftedDate.format(FORMAT_DATE_STD);
}

export function findSmallestDate(possTimezones: string[]): string {
    if (isNil(possTimezones) || possTimezones.length === 0) {
        return "";
    }

    const smallestDate = possTimezones.reduce((currentSmallestDate, tz) => {
        const date = getShiftedDate(moment().toDate(), moment.duration("29:00"), tz);

        if (!currentSmallestDate || moment(date).isBefore(currentSmallestDate)) {
            return date;
        }

        return currentSmallestDate;
    }, null);

    return smallestDate;
}

export function getDaysBetween(from?: Date, to?: Date): number[] {
    if (isNil(from) || isNil(to)) {
        return ALL_DAYS_OF_THE_WEEK;
    }

    const days: number[] = [];
    const date = moment(from);

    while (days.length < 7 && date.isSameOrBefore(to, "d")) {
        days.push(date.day());

        date.add(1, "days");
    }

    return days;
}

export function getDowListBetweenDate(from: Date, to: Date): number[] {
    if (moment(from).isAfter(moment(to))) {
        console.error(
            "getDowListBetweenDate: 'from' date is after 'to' date. Returning empty array."
        );
        return [];
    }
    const days: number[] = [];
    const date = moment(from);

    while (date.isSameOrBefore(to, "d")) {
        days.push(date.day());
        date.add(1, "days");
    }

    return days;
}
